import {Component, OnInit} from "@angular/core";
import {NgbModule, NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {UserService} from "../../../services/user.service";
import {debounceTime, distinctUntilChanged, filter, from, map, mergeMap, Observable, OperatorFunction} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {o} from "odata";
import {Employee, HubUser, Message} from "../../../apis/backend";

@Component({
    selector: 'message-dialog',
    templateUrl: './message-dialog.component.html',
})
export class MessageDialogComponent implements OnInit {

    public Message: Message = <Message>{};
    public CurrentUser: HubUser;
    
    constructor(public ActiveModal: NgbActiveModal,
                public HttpService: HttpClient,
                public UserService: UserService) {
        UserService.CurrentUser.subscribe((user: HubUser) => {
            this.CurrentUser = user;
        });
    }

    ngOnInit(): void {
        this.Message.RecipientEmployee = this.Message.RecipientEmployee || this.CurrentUser.EmployeeInfo;
        this.Message.CallReceivedDate = this.Message.CallReceivedDate || new Date().toISOString();
    }
    
    public ParseDate(dateStr: string) {
        return new Date(dateStr);
    }

    public EmployeeSearch: OperatorFunction<string, readonly Employee[]> = (searchTerm: Observable<string>) => searchTerm.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        filter(term => term.length >= 2),
        mergeMap(term => {
            term = term.toLowerCase().replace("'", "''");
            return from(o('/', { credentials: 'include' })
                .get('odata/employees')
                .fetch({
                    $filter: `contains(tolower(FirstName), '${term}') or contains(tolower(LastName), '${term}')`,
                    $top: 10
                })
                .then(response => {
                    return (<any>response).json();
                })
                .then(odata => {
                    return odata.value;
                }));
        })
    );

    public FormatEmployee(employee: Employee) {
        return employee.FirstName + ' ' + employee.LastName;
    }
    
    public Save() {
        this.ActiveModal.close(this.Message);
    }
    
    public Cancel() {
        this.ActiveModal.dismiss();
    }
}